<template>
  <Header>
    <template #menu-main>
      <div class="Menu__main">
        <li class="Menu__item">
          <a href="/" class="Menu__link">{{ $t("VUE.MAIN_PAGE") }}</a>
        </li>
      </div>
    </template>

    <template #socials>
      <Socials />
    </template>

    <template #share>
      <Share wrapper="Nav" :icons="share.icons" />
    </template>
  </Header>
</template>

<script>
import { Header } from "@/components";
import { Socials, Share } from "@/components/app";
import { mapGetters } from "vuex";

export default {
  name: "AuxiliaryHeader",
  computed: {
    ...mapGetters(["share"])
  },
  components: {
    Header,
    Socials,
    Share
  }
};
</script>
